export default __webpack_public_path__ + "static/media/temp-results-img-3.0b7b877e.jpg";